var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Plugins } from '@capacitor/core';
import { flow, observable, reaction } from 'mobx';
import { reportError } from '../utils/errors.utils';
var Storage = Plugins.Storage;
export var makeStorageController = function (appInstanceId, appShortName) {
    if (appInstanceId === void 0) { appInstanceId = ''; }
    if (appShortName === void 0) { appShortName = 'app'; }
    var makeKey = function () {
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        return __spreadArray([appInstanceId, appShortName], keys.flat(), true).join(':');
    };
    var makePublicKey = function () {
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        return __spreadArray([appInstanceId, appShortName, 'PUBLIC'], keys.flat(), true).join(':');
    };
    var encode = function (input) { return JSON.stringify(input); };
    var decode = function (input) {
        if (typeof input === 'string') {
            try {
                return JSON.parse(input);
            }
            catch (e) {
                console.error(e);
                console.log(input);
                return input;
            }
        }
        return null;
    };
    var getKeysByNamespace = function () {
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var keyPartial, allKeys, matchingKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        keyPartial = makeKey.apply(void 0, keys);
                        return [4 /*yield*/, Storage.keys()];
                    case 1:
                        allKeys = _a.sent();
                        matchingKeys = allKeys.keys.filter(function (k) { return k.match(new RegExp(keyPartial)); });
                        return [2 /*return*/, matchingKeys];
                }
            });
        });
    };
    var store = function (key, valueSource, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var value, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        value = encode(valueSource);
                        return [4 /*yield*/, Storage.set({ key: key, value: value })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        reportError(e_1);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var c = observable({
        $root: null,
        get: function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                keys[_i] = arguments[_i];
            }
            return __awaiter(void 0, void 0, void 0, function () {
                var key, snapshot, value, publicKey, publicSnapshot, publicValue, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            key = makeKey.apply(void 0, keys.flat());
                            return [4 /*yield*/, Storage.get({ key: key })];
                        case 1:
                            snapshot = _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            value = decode(snapshot.value);
                            if (value !== null)
                                return [2 /*return*/, value];
                            publicKey = makePublicKey.apply(void 0, keys.flat());
                            return [4 /*yield*/, Storage.get({ key: publicKey })];
                        case 3:
                            publicSnapshot = _a.sent();
                            publicValue = decode(publicSnapshot.value);
                            return [2 /*return*/, publicValue !== null && publicValue !== void 0 ? publicValue : value];
                        case 4:
                            e_2 = _a.sent();
                            reportError(e_2);
                            return [2 /*return*/, null];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        getByNamespace: function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                keys[_i] = arguments[_i];
            }
            return __awaiter(void 0, void 0, void 0, function () {
                var keysToGet, promises_1, snapshots, e_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getKeysByNamespace.apply(void 0, keys)];
                        case 1:
                            keysToGet = _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            promises_1 = keysToGet.map(function (key) { return ({
                                key: key,
                                promise: Storage.get({ key: key }),
                            }); });
                            return [4 /*yield*/, Promise.all(promises_1.map(function (p) { return p.promise; }))];
                        case 3:
                            snapshots = _a.sent();
                            return [2 /*return*/, snapshots.map(function (snapshot, i) {
                                    var _a;
                                    return (_a = {},
                                        _a[promises_1[i].key] = decode(snapshot.value),
                                        _a);
                                }).reduce(function (a, b) { return (__assign(__assign({}, a), b)); }, {})];
                        case 4:
                            e_3 = _a.sent();
                            return [2 /*return*/, []];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        set: function (keys, valueSource, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(void 0, void 0, void 0, function () {
                var key;
                return __generator(this, function (_a) {
                    key = makeKey.apply(void 0, keys);
                    return [2 /*return*/, store(key, valueSource, options)];
                });
            });
        },
        setPublic: function (keys, valueSource, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(void 0, void 0, void 0, function () {
                var key;
                return __generator(this, function (_a) {
                    key = makePublicKey.apply(void 0, keys);
                    return [2 /*return*/, store(key, valueSource, options)];
                });
            });
        },
        remove: function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                keys[_i] = arguments[_i];
            }
            return __awaiter(void 0, void 0, void 0, function () {
                var key, publicKey;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            key = makeKey.apply(void 0, keys);
                            publicKey = makePublicKey.apply(void 0, keys);
                            return [4 /*yield*/, Promise.all([
                                    Storage.remove({ key: key }),
                                    Storage.remove({ key: publicKey }),
                                ])];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        removeByNamespace: function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                keys[_i] = arguments[_i];
            }
            return __awaiter(void 0, void 0, void 0, function () {
                var key;
                return __generator(this, function (_a) {
                    key = makeKey.apply(void 0, keys);
                    return [2 /*return*/, Storage.remove({ key: key })];
                });
            });
        },
        clear: function () { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Storage.clear()];
                    case 1:
                        _a.sent();
                        resolve();
                        return [2 /*return*/];
                }
            });
        }); }); },
        syncObservableValueToStorage: function (keys, getter, setter, options) {
            var dispose = reaction(function () { return getter(); }, function (v) { return c.set(keys, v); });
            var syncState = observable({
                getStoredValue: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, c.get(keys)];
                                case 1: return [2 /*return*/, (_a.sent())];
                            }
                        });
                    });
                },
                dispose: dispose,
            });
            return syncState;
        },
        clearNonPublic: function () { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var allKeys, publicKeys, allPublicKeyValues, allPublicKeyValuesDecoded;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('clearing sensitive data');
                        return [4 /*yield*/, Storage.keys()];
                    case 1:
                        allKeys = _a.sent();
                        publicKeys = allKeys.keys.filter(function (key) { return key.split(':')[1] === 'PUBLIC'; });
                        return [4 /*yield*/, Promise.all(publicKeys.map(function (key) { return Storage.get({ key: key }); }))];
                    case 2:
                        allPublicKeyValues = _a.sent();
                        allPublicKeyValuesDecoded = allPublicKeyValues.map(function (v) { return decode(v.value); });
                        return [4 /*yield*/, Storage.clear()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(publicKeys.map(function (key, i) { return Storage.set({
                                key: key,
                                value: encode(allPublicKeyValuesDecoded[i])
                            }); }))];
                    case 4:
                        _a.sent();
                        resolve();
                        return [2 /*return*/];
                }
            });
        }); }); },
        $init: flow(function (root) {
            return __generator(this, function (_a) {
                c.$root = root;
                return [2 /*return*/];
            });
        }),
        $reset: function () {
            c.clearNonPublic();
        }
    });
    var watchForStorageChanges = function () {
        var handler = function (e) {
            var _a;
            console.log(e);
            if ((_a = e.key) === null || _a === void 0 ? void 0 : _a.match(/_cap_[^:]*::auth/)) {
                console.warn('Auth related storage key changed externally');
                if (e.key.includes('logout') && e.newValue === 'true') {
                    // const AUTH = c.ROOT?.children.AUTH;
                    // if (AUTH?.isAuthenticated) {
                    //   AUTH.logout();
                    //   window.removeEventListener('storage', handler);
                    // }
                }
            }
        };
        window.addEventListener('storage', handler);
    };
    return c;
};
